webpackJsonp([217821140753636],{

/***/ 969:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0018_eggship.jpg","type":"Unit","subtype":"Contraption","cost":4,"ATK":4,"HP":3,"rules_text_1":"Flying (Can fly over ground patrollers. Ground forces without anti-air can't attack this or deal combat damage to it when attacked.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Eggship","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"This somewhat-safe mode of transportation has been converted to a warship.","color":"Neutral","spec":"Bashing","bottom":"Tech II","rulings":[],"keywords":["Flying"],"slug":"eggship"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"eggship","keywords":["Flying"],"imageRegex":"/eggship.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-eggship-ba61bf83245da47a1c8f.js